// @vue/component
import {
  subjectDetailApi,
  subjectAllApi,
  subjectLoading
} from "@/api/subjects";
import { projectDetailApi } from "@/api/project";
import { getProjectId, getProStatus } from "@/utils/auth";
import nextVisit from "./nextVisit/nextVisit";
import look from "./look/look.vue";
import remark from "./remark/remark.vue";
import top from "./top/top.vue";
import add from "./add/add.vue";
import { unitAllNoPage, unitMyAllResearchCenter } from "@/api/unit";

export default {
  name: "Index",

  components: {
    nextVisit: nextVisit,
    look: look,
    remark: remark,
    top: top,
    add
  },

  mixins: [],

  props: {},

  data() {
    return {
      projectGroup: {
        "62f9f0dcc43d533bd20f99a1": "组别",
        "6476bc96ad1ad354ffb4b15c": "组别",
        "66f4f33fd9db58c6e3e199e2": "组别",
        "672c28f5ca8f158893345f2d": "组别",
        "6513d5c49c140b4bd8c0ceb8": "组名",
        "6729ad6bca8f15889334565a": "组别",
        "68931bd4821f239505a856da": "组别",
        "69644ed3eef6c246fc90a406": "随机分组",
        "6976f995ae36518830df073a": "随机分组"
      },
      projectDateMap: {
        "63919eaef86d0682b94669fd": "签署知情时间",
        "63410c94eaea91a48060aeb8": "随机日期",
        "6476ce88d477c932cf3e17bf": "随机时间",
        "6513d5c49c140b4bd8c0ceb8": "随机时间",
        "66c70559fc0a6b41e1351831": "随机时间",
        "66cbf3c0fc0a6b41e1352826": "知情同意书签署日期",
        "6729ad6bca8f15889334565a": "随机时间",
        "67ede6da43107079f586f07b": "知情同意书签署时间",
        "6a3a51fa04ac36255ee907c3": "知情时间",
        "6a3dd4ec24f5db851d8016b9": "随机时间",
        "6a66c6715f164366b3de026c": "随机时间",
        "6aa222ac1c6db8088da6b552": "随机时间"
      },
      project: {}, // 项目详情
      subject: {}, // 选中的受试者详情
      subjectId: "", // 选中的那一行的受试者ID
      nextDialogVisible: false,
      proStatus: getProStatus(),
      project_id: getProjectId(),
      key: "",
      page: 0,
      page_size: 10,
      unit_id_list: [], // 筛选的所有单位id
      subject_list: [], // 所有请求获取到的受试者
      cellStyle: {
        textAlign: "center"
      },
      unit_list: [], // 所有入组中心，用来筛选
      lookDialogVisible: false, // 控制查看弹窗
      remarkDialogVisible: false, // 控制备注弹窗是否显示
      total: 0, // 受试者总数量
      addDialogVisible: false, // 控制登记受试者弹窗的显示
      select_list: [],
      subjectInfo: {},
      roles: this.$store.getters.roles,
      is_disabled: false,
      loading: this.$loading({
        lock: true,
        text: "随机中，请勿关闭/刷新此页面",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
        customClass: "loadingBox_"
      }),
      timer: null,
      envName: sessionStorage.getItem("iwrs_environment"),
      // 需要隐藏入组时间的项目ids
      unShowList: [
        "62f9f0dcc43d533bd20f99a1",
        "62970c755a08ad1af5d3295f",
        "6305b6ed048cec1f511d8e06",
        "6476bc96ad1ad354ffb4b15c",
        "64e843888dfa6a8de671cdff",
        "6528e3569c140b4bd8c79dd7",
        "676a26d1e38a8ebcd771a00b"
      ],
      UATUnShowList: [
        "64096d9e864ff9db7cee37c8",
        "63db10fabbae4962a9dadbd2",
        "64191c906e014b193a343f28",
        "6419275437a4507c1d49ab08"
      ]
    };
  },

  computed: {},

  watch: {},
  destroyed() {
    // 离开页面销毁
    clearInterval(this.timer);
    this.timer = null;
  },
  created() {
    this.isSubjectLoading();
    // 获取所有单位，用来筛选入组中心
    this.getUnitList();
    // 获取项目详情
    this.getProjectDetail();
  },

  methods: {
    stop() {
      clearInterval(this.timer);
      this.timer = null;
    },
    async isSubjectLoading() {
      this.stop();
      try {
        const { data } = await subjectLoading({ project_id: this.project_id });
        if (data && data.loading) {
          this.loading;
          this.timer = window.setInterval(() => {
            setTimeout(this.isSubjectLoading(), 0);
          }, 1500);
        } else {
          this.stop();
          this.loading.close();
          this.getSubjectList();
        }
      } catch (error) {
        this.loading.close();
      }
    },
    selectable(row) {
      if (!row.is_unactive) {
        return true;
      } else {
        return false;
      }
    },
    cancelDialog() {
      this.addDialogVisible = false;
      this.is_disabled = false;
      this.subjectInfo = {};
    },
    handleSelectionChange(val) {
      this.select_list = val;
    },
    filterChange(filter) {
      // 入组中心选择事件
      console.log(filter);
      this.unit_id_list = filter.unit_name;
      this.getSubjectList();
    },
    refresh(key) {
      this.key = key;
      // 获取所有受试者
      this.getSubjectList();
    },
    getUnitList() {
      // 获取所有单位，用来筛选入组中心
      unitMyAllResearchCenter(this, this.project_id, res => {
        if (res.data && res.data.length > 0) {
          this.unit_list = res.data.map(item => {
            const obj = {};
            obj.text = item.name;
            obj.value = item.name;
            obj.id = item.id;
            obj.code = item.code;
            obj.doctor = item.main_researchers;
            obj.enable = item.enable;
            return obj;
          });
          this.unit_list.sort((a, b) => {
            return parseInt(a.code) > parseInt(b.code) ? 1 : -1;
          });
        } else {
          this.unit_list = [];
        }
      });
    },
    showSubject() {
      this.is_disabled = false;
      this.subjectInfo = {};
      // console.log(this.project.new_parameter_list)
      this.$forceUpdate();
      this.addDialogVisible = true;
      setTimeout(() => {
        this.$refs.add.loading = false;
      }, 0);
    },
    sumbitReg(item) {
      // console.log(item)
      this.is_disabled = true;
      this.addDialogVisible = true;
      this.subjectInfo = item;
    },
    getSelectName(list, value) {
      let res;
      list.forEach(i => {
        if (i.code === value) {
          res = i.code_desc;
        }
      });
      return res;
    },
    getProjectDetail() {
      // 获取项目详情
      projectDetailApi(this, this.project_id, res => {
        this.project = res.data;
        // 获取所有受试者
        this.getSubjectList();
      });
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.is_unactive) {
        return "is_un_active-row";
      }
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      // 改表头颜色
      if (rowIndex === 0) {
        return "background-color: rgb(214, 228, 255);color: #595959;text-align:center;padding: 6px 0;font-size:12px";
      }
    },
    getSubjectList() {
      // 获取所有受试者
      const data = {
        project_id: this.project_id,
        key: this.key,
        page: this.page - 1,
        page_size: this.page_size,
        unit_id_list: this.unit_id_list
      };
      return subjectAllApi(this, data).then(res => {
        this.subject_list = res.data;
        this.total = res.total;
      });
    },
    showNextView(row) {
      // 显示进入下一个访视的弹窗
      this.subjectId = row.id;
      // 点击查看按钮
      const params = {
        project_id: this.project_id,
        id: row.id
      };
      subjectDetailApi(this, params, res => {
        this.subject = res.data;
        this.nextDialogVisible = true;
      });
    },
    nextVisitCancel() {
      // 下一个访视弹窗取消事件
      this.nextDialogVisible = false;
    },
    async nextVisitOk() {
      const ids = [
        "62f9f0dcc43d533bd20f99a1",
        "62970c755a08ad1af5d3295f",
        "6476bc96ad1ad354ffb4b15c"
      ];
      // 下一个访视弹窗确定并且接口完成事件
      this.nextDialogVisible = false;
      this.remarkDialogVisible = false;
      this.addDialogVisible = false;
      await this.getSubjectList();
      if (ids.includes(this.project_id)) {
        this.showLook(this.subject_list[0]);
      }
    },
    showLook(row) {
      this.subjectId = row.id;
      // 点击查看按钮
      const params = {
        project_id: this.project_id,
        id: row.id
      };
      subjectDetailApi(this, params, res => {
        this.subject = res.data;
        this.lookDialogVisible = true;
      });
    },
    showRemark(row) {
      this.subjectId = row.id;
      // 点击查看按钮
      const params = {
        project_id: this.project_id,
        id: row.id
      };
      subjectDetailApi(this, params, res => {
        this.subject = res.data;
        this.remarkDialogVisible = true;
      });
    },
    handleSizeChange(val) {
      this.page_size = val;
      this.page = 1;
      this.getSubjectList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getSubjectList();
    }
  }
};
